"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Step = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const step_styles_1 = require("@/components/indicators/step/step.styles");
require("@/components/indicators/step/step-item");
/**
 * <mm-step>
 * 단계를 순서대로 늘어놓고 단계를 잇는 선을 그리는 진행 표시입니다.
 * 번호와 orientation은 항목마다 받지 않고 순서를 소유한 이 그룹이 채웁니다.
 */
let Step = class Step extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.orientation = 'horizontal';
    }
    connectedCallback() {
        super.connectedCallback();
        this.setAttribute('role', 'list');
    }
    updated(changed) {
        if (!changed.has('orientation'))
            return;
        this.syncItems();
    }
    render() {
        return (0, lit_1.html) `
      <slot @slotchange=${this.handleSlotChange}></slot>
    `;
    }
    handleSlotChange() {
        this.syncItems();
    }
    syncItems() {
        this.items.forEach((item, index) => {
            item.orientation = this.orientation;
            item.value = index + 1;
        });
    }
};
Step.styles = step_styles_1.stepStyles;
__decorate([
    (0, decorators_js_1.property)({ type: String, reflect: true })
], Step.prototype, "orientation", void 0);
__decorate([
    (0, decorators_js_1.queryAssignedElements)({ flatten: true, selector: 'mm-step-item' })
], Step.prototype, "items", void 0);
Step = __decorate([
    (0, decorators_js_1.customElement)('mm-step')
], Step);
exports.Step = Step;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3RlcC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInN0ZXAudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUEsNkJBQTJEO0FBQzNELHFEQUFrRjtBQUlsRiwwRUFBcUU7QUFDckUsa0RBQStDO0FBRS9DOzs7O0dBSUc7QUFFSSxJQUFNLElBQUksR0FBVixNQUFNLElBQUssU0FBUSxnQkFBVTtJQUE3Qjs7UUFFc0MsZ0JBQVcsR0FBb0IsWUFBWSxDQUFBO0lBK0J4RixDQUFDO0lBM0JDLGlCQUFpQjtRQUNmLEtBQUssQ0FBQyxpQkFBaUIsRUFBRSxDQUFBO1FBQ3pCLElBQUksQ0FBQyxZQUFZLENBQUMsTUFBTSxFQUFFLE1BQU0sQ0FBQyxDQUFBO0lBQ25DLENBQUM7SUFFUyxPQUFPLENBQUMsT0FBdUI7UUFDdkMsSUFBSSxDQUFDLE9BQU8sQ0FBQyxHQUFHLENBQUMsYUFBYSxDQUFDO1lBQUUsT0FBTTtRQUV2QyxJQUFJLENBQUMsU0FBUyxFQUFFLENBQUE7SUFDbEIsQ0FBQztJQUVELE1BQU07UUFDSixPQUFPLElBQUEsVUFBSSxFQUFBOzBCQUNXLElBQUksQ0FBQyxnQkFBZ0I7S0FDMUMsQ0FBQTtJQUNILENBQUM7SUFFTyxnQkFBZ0I7UUFDdEIsSUFBSSxDQUFDLFNBQVMsRUFBRSxDQUFBO0lBQ2xCLENBQUM7SUFFTyxTQUFTO1FBQ2YsSUFBSSxDQUFDLEtBQUssQ0FBQyxPQUFPLENBQUMsQ0FBQyxJQUFJLEVBQUUsS0FBSyxFQUFFLEVBQUU7WUFDakMsSUFBSSxDQUFDLFdBQVcsR0FBRyxJQUFJLENBQUMsV0FBVyxDQUFBO1lBQ25DLElBQUksQ0FBQyxLQUFLLEdBQUcsS0FBSyxHQUFHLENBQUMsQ0FBQTtRQUN4QixDQUFDLENBQUMsQ0FBQTtJQUNKLENBQUM7O0FBL0JNLFdBQU0sR0FBRyx3QkFBVSxDQUFBO0FBQ2lCO0lBQTFDLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsT0FBTyxFQUFFLElBQUksRUFBRSxDQUFDO3lDQUE0QztBQUV0RjtJQURDLElBQUEscUNBQXFCLEVBQUMsRUFBRSxPQUFPLEVBQUUsSUFBSSxFQUFFLFFBQVEsRUFBRSxjQUFjLEVBQUUsQ0FBQzttQ0FDekM7QUFKZixJQUFJO0lBRGhCLElBQUEsNkJBQWEsRUFBQyxTQUFTLENBQUM7R0FDWixJQUFJLENBaUNoQjtBQWpDWSxvQkFBSSJ9